import React from 'react';
import PropTypes from 'prop-types';

import Link from '~/src/components/link/Link';
import HtmlText from '~/src/components/htmlText/HtmlText';

import {getContentUrl} from '~/src/utilities/helpers/link';

const InternalLink = ({htmlText, url}) => {
    if (!htmlText) {
        return null;
    }

    const innerHtml = <HtmlText htmlText={htmlText} />;

    if (url) {
        return <Link href={getContentUrl(url)}>{innerHtml}</Link>;
    }

    return innerHtml;
};

if (process.env.NODE_ENV === 'development') {
    InternalLink.propTypes = {
        url: PropTypes.string,
        htmlText: PropTypes.string
    };
}

export default InternalLink;
